import React, { useCallback, useState } from 'react';

import { useDrawer } from '~/hooks/useDrawer';
import { CaretDown } from '~/ui/assets/icons';
import { Popover } from '~/ui/components';
import { contractRouteOf, TicketContract } from '~/components/Ticket/common/ticketContracts';
import {
  ContractFieldValue,
  List,
  Link,
  ContractPopoverItem,
  ContractPopoverRow,
  ContractPopoverDetail,
  ContractPopoverConsignee,
} from './TicketContractsPopover.styled';

type TicketContractsPopoverProps = {
  contracts: TicketContract[];
};

export function TicketContractsPopover({ contracts }: Readonly<TicketContractsPopoverProps>) {
  const { closeAllDrawers } = useDrawer();
  const [isVisible, setIsVisible] = useState(false);

  const handleLinkCLick = useCallback(() => {
    closeAllDrawers();
    setIsVisible(false);
  }, []);

  const renderContractLink = (contract: TicketContract) => {
    const route = contractRouteOf(contract);

    if (!route) {
      return <span>Não informado</span>;
    }

    return (
      <Link onClick={handleLinkCLick} to={route.url}>
        #{route.label}
      </Link>
    );
  };

  const hasExtraInfo = contracts.some((c) => c.financialInstitutionName || c.bankName);

  if (contracts.length === 1 && !hasExtraInfo) {
    return renderContractLink(contracts[0]);
  }

  return (
    <Popover
      trigger="click"
      width={320}
      onVisibleChange={(ev) => setIsVisible(ev)}
      visible={isVisible}
      noHeader
      content={
        <List>
          {contracts.map((contract) => (
            <ContractPopoverItem key={contract.id}>
              <ContractPopoverRow>
                {renderContractLink(contract)}
                {contract.financialInstitutionName && (
                  <ContractPopoverDetail>•&nbsp;{contract.financialInstitutionName}</ContractPopoverDetail>
                )}
              </ContractPopoverRow>
              {contract.bankName && (
                <ContractPopoverConsignee>
                  Consignatária:{' '}
                  {contract.bankNumber ? `${contract.bankName} (${contract.bankNumber})` : contract.bankName}
                </ContractPopoverConsignee>
              )}
            </ContractPopoverItem>
          ))}
        </List>
      }
    >
      <ContractFieldValue>
        <p>#{contractRouteOf(contracts[0])?.label || '-'}</p>
        <CaretDown className="action-icon" width={14} height={14} />
      </ContractFieldValue>
    </Popover>
  );
}
